import { createContext } from 'react'

/**
 * Wallet contexts live in their own wagmi-free module.
 *
 * `WalletProvider.tsx` statically imports `wagmi`, which transitively pulls
 * in WalletConnect internals used by Reown AppKit. When `prerender.tsx`
 * (the Node/SSR entry used by `vite-prerender-plugin`) imports that graph,
 * Rollup bundles WalletConnect's `@walletconnect/jsonrpc-ws-connection`
 * package into the server chunk, and Node's ESM loader throws
 * `ReferenceError: require is not defined in ES module scope` on its
 * `require("ws")` fallback line.
 *
 * Keeping these contexts here lets a prerender-only stand-in provider
 * (`WalletProviderStatic`) supply the same "not ready" defaults without
 * ever importing `wagmi` or `@reown/appkit-adapter-wagmi`, so the SSR build
 * never reaches that WalletConnect code path.
 */

/** True only once `createAppKit()` has actually been called on the client. */
export const WalletReadyContext = createContext(false)

/** Connected EOA when AppKit/wagmi is ready; undefined otherwise. */
export const WalletAddressContext = createContext<string | undefined>(undefined)
